// Pre-translated UI text for instant language switching
export const TRANSLATIONS = {
  zh: {
    // Navigation
    "Cerebro": "大脑",
    "Dashboard": "仪表板",
    "Nodes": "节点",
    "Sandbox": "沙盒",
    "Superbrain": "超级大脑",
    "Proof Logs": "证明日志",
    "Compute Credits": "计算积分",
    "Marketplace": "市场",
    "RoboMesh": "机器人网格",
    "Governance": "治理",
    "Settings": "设置",
    "Profile": "个人资料",
    "Demo User": "演示用户",
    "DEVELOPER": "开发者",
    "Display Name": "显示名称",
    "Email": "电子邮件",
    "Role": "角色",
    "Developer": "开发者",
    "Notifications": "通知",
    "Push Notifications": "推送通知",
    "Receive real-time alerts in the console": "在控制台接收实时警报",
    "Email Alerts": "电子邮件警报",
    "Critical alerts sent to your email": "将重要警报发送到您的电子邮件",
    "Sound Effects": "声音效果",
    "Audio feedback for notifications": "通知的音频反馈",
    "Appearance": "外观",
    "Theme": "主题",
    "Dark (Default)": "深色（默认）",
    "Language": "语言",
    "English": "英语",
    "Security": "安全",
    "API Keys": "API密钥",
    "Manage your API access tokens": "管理您的API访问令牌",
    "Active Sessions": "活跃会话",
    "View and manage logged in devices": "查看和管理已登录的设备",
    "1 Active": "1个活跃",
    "Logout": "登出",
    "Save Changes": "保存更改",
    "Danger Zone": "危险区域",
    "Delete Account": "删除账户",
    "Permanently delete your account and all data": "永久删除您的账户和所有数据",
    "Manage": "管理",
    "SOON": "即将推出",
    
    // Landing Page - EVERY WORD
    "Network Active": "网络活跃",
    "The Intelligence Layer for": "智能层",
    "On-Robot Compute": "机器人计算",
    "ACTIVE NODES": "活跃节点",
    "INFERENCE/SEC": "推理/秒",
    "Launch App": "启动应用",
    "INFERENCE/SEC": "推理/秒",
    "Orchestrate your robotic fleet with cryptographic proofs, decentralized intelligence, and real-time telemetry. The future of autonomous systems starts here.": "通过加密证明、去中心化智能和实时遥测来编排您的机器人群。自主系统的未来从这里开始。",
    "CONTINUE WITH GOOGLE": "使用GOOGLE继续",
    "Continue with Google": "使用Google继续",
    "Connecting...": "连接中...",
    "Continue as Guest": "以访客身份继续",
    "Or sign in with email": "或使用电子邮件登录",
    "By continuing, you agree to the NeuroMesh Terms of Service": "继续即表示您同意NeuroMesh服务条款",
    "Node Management": "节点管理",
    "Monitor and control your fleet of humanoid robots and edge devices": "监控和控制您的人形机器人和边缘设备群",
    "AI Inference": "AI推理",
    "Run distributed inference with cryptographic proof verification": "运行带有加密证明验证的分布式推理",
    "Secure Enclaves": "安全飞地",
    "Hardware-attested security for sensitive robotic operations": "用于敏感机器人操作的硬件认证安全",
    "Real-time Telemetry": "实时遥测",
    "Stream live data from your entire robotic network": "从您的整个机器人网络流式传输实时数据",
    "Meet Cerebro": "认识Cerebro",
    "Try Cerebro": "试用Cerebro",
    "Your intelligent assistant with 10 specialized modes — Executive Advisory, Science Mode, Creative Brainstorming, and more. Try it now.": "您的智能助手拥有10种专业模式 - 高管咨询、科学模式、创意头脑风暴等。立即试用。",
    
    // Compute Credits Page
    "Manage your compute balance and transactions": "管理您的计算余额和交易",
    "Programmable on-robot compute units backed by the $NEURO token": "由$NEURO代币支持的可编程机器人计算单元",
    "⚠️ Testnet Preview": "⚠️ 测试网预览",
    "This dashboard simulates Compute Credit minting mechanics and supply flows.": "此仪表板模拟计算积分铸造机制和供应流程。",
    "$NEURO to Credit conversion is not yet active.": "$NEURO到积分的转换尚未激活。",
    "No tokens can be locked or burned at this stage.": "在此阶段无法锁定或销毁代币。",
    "What Are Compute Credits?": "什么是计算积分？",
    "Compute Credits are non-transferable network units that will represent:": "计算积分是不可转让的网络单位，将代表：",
    "Verified inference execution": "已验证的推理执行",
    "Training epochs contributed by robots": "机器人贡献的训练周期",
    "Simulation runs inside Cerebro and RoboMesh": "Cerebro和RoboMesh内的模拟运行",
    "Agent marketplace usage": "代理市场使用",
    "Attested GPU or edge compute routed through NeuroMesh": "通过NeuroMesh路由的认证GPU或边缘计算",
    "Proof of Inference and Proof of Action receipts": "推理证明和操作证明收据",
    "Once live,": "一旦上线，",
    "Compute Credits will be minted by locking $NEURO into protocol contracts.": "计算积分将通过将$NEURO锁定到协议合约中来铸造。",
    "Each wallet will permanently display: Total credits minted • Credits consumed • Credits remaining • Lifetime network contribution • Robot nodes serviced • Agent workflows executed": "每个钱包将永久显示：铸造的总积分 • 消耗的积分 • 剩余积分 • 终身网络贡献 • 服务的机器人节点 • 执行的代理工作流",
    "Immutable Once Live": "上线后不可变",
    "Lifetime Compute Credits": "终身计算积分",
    "This counter becomes": "此计数器变为",
    "immutable once minting is enabled on mainnet": "一旦在主网上启用铸造就不可变",
    "It will permanently record every Compute Credit ever minted by this wallet. During testnet, this value is simulated.": "它将永久记录此钱包铸造的每个计算积分。在测试网期间，此值是模拟的。",
    "Minting Simulator (Testnet Preview)": "铸造模拟器（测试网预览）",
    "$NEURO to Lock": "要锁定的$NEURO",
    "Lock Duration": "锁定期限",
    "7 days": "7天",
    "30 days": "30天",
    "90 days": "90天",
    "Network Load Mode": "网络负载模式",
    "Low": "低",
    "Normal": "正常",
    "High": "高",
    "Run Simulation": "运行模拟",
    "Simulated Credits Minted": "模拟铸造的积分",
    "Cost per Inference": "每次推理成本",
    "Robots Serviced": "服务的机器人",
    "Agent Tasks Executed": "执行的代理任务",
    "GPU Seconds Allocated": "分配的GPU秒数",
    "Attestation Proofs": "认证证明",
    "Network Fee Burned": "销毁的网络费用",
    "Credits Remaining": "剩余积分",
    "Simulation": "模拟",
    "Conversion Curve": "转换曲线",
    "Simulation Data Only": "仅模拟数据",
    "$NEURO Locked": "$NEURO已锁定",
    "Credits Minted": "铸造的积分",
    "Low Network Load": "低网络负载",
    "Normal Network Load": "正常网络负载",
    "High Network Load": "高网络负载",
    "Rates shown are testnet simulations and subject to governance before mainnet": "显示的费率是测试网模拟，主网前需接受治理",
    "Supply Flow Visualization": "供应流可视化",
    "Locked $NEURO": "锁定的$NEURO",
    "Credits Issued": "发行的积分",
    "Credits Burned": "销毁的积分",
    "Recycled to Pool": "回收到池中",
    "Illustrative preview of protocol flows. Contracts not yet deployed.": "协议流程的示例预览。合约尚未部署。",
    "Credit Consumption Breakdown": "积分消耗细分",
    "Attestation Counters": "认证计数器",
    "Simulated": "模拟的",
    "Proof of Inference Generated": "生成的推理证明",
    "Proof of Action Generated": "生成的操作证明",
    "Audit Records Stored": "存储的审计记录",
    "Testnet Disclosure": "测试网披露",
    "Compute Credits are not currently mintable.": "计算积分目前无法铸造。",
    "The minting mechanism using $NEURO tokens is under active development and has not yet been deployed on mainnet.": "使用$NEURO代币的铸造机制正在积极开发中，尚未在主网上部署。",
    "All charts, counters, and projections shown in this section are generated by a simulation engine designed to preview potential protocol dynamics.": "本节中显示的所有图表、计数器和预测均由旨在预览潜在协议动态的模拟引擎生成。",
    "These values do not represent real network usage or token flows.": "这些值不代表实际的网络使用或代币流动。",
    "Once live, Compute Credit minting will be governed by onchain contracts, published conversion formulas, and public audits.": "一旦上线，计算积分铸造将由链上合约、公布的转换公式和公开审计管理。",
    "Mainnet Launch Will Introduce": "主网启动将引入",
    "Immutable lifetime credit counters": "不可变的终身积分计数器",
    "per wallet": "每个钱包",
    "Onchain minting contracts": "链上铸造合约",
    "with transparent conversion formulas": "具有透明的转换公式",
    "Burn and recycle mechanics": "销毁和回收机制",
    "for protocol sustainability": "用于协议可持续性",
    "Governance controlled conversion curves": "治理控制的转换曲线",
    "voted by $NEURO holders": "由$NEURO持有者投票",
    "Public dashboards": "公共仪表板",
    "with real-time network analytics": "具有实时网络分析",
    "Proof explorer": "证明浏览器",
    "for every credit spent": "用于每笔积分支出",
    "Historical network analytics": "历史网络分析",
    "and attribution": "和归因",
    "Robot node revenue attribution": "机器人节点收入归因",
    "for compute providers": "用于计算提供者",
    "Training": "训练",
    "Runtime": "运行时",
    "Audit": "审计",
    "Mint Credits": "铸造积分",
    "Total Balance": "总余额",
    "Usage Overview": "使用概览",
    "Today": "今天",
    "This Week": "本周",
    "of 200 daily allocation": "每日分配的200中",
    "of 1000 weekly allocation": "每周分配的1000中",
    "Credit Flow": "积分流动",
    "Recent Transactions": "最近交易",
    "Amount": "金额",
    "Description": "描述",
    "Time": "时间",
    
    // Common
    "Loading...": "加载中...",
    "Search": "搜索",
    "Thinking...": "思考中...",
    "Reasoning...": "推理中...",
    
    // RoboMesh
    "Simple Mode": "简单模式",
    "Expert Mode": "专家模式",
    "Solve Tasks": "解决任务",
    "Simulate": "模拟",
    "Insights": "见解",
    "Suggested next steps": "建议的下一步",
    "Simulate This Task": "模拟此任务",
    "Solve": "解决",
    "Universal reasoning engine for real-world action": "现实世界行动的通用推理引擎",
    
    // Sandbox/Marketplace
    "Sandbox Agents": "沙盒代理",
    "Testing and validation agents for humanoid robots": "人形机器人的测试和验证代理",
    "Validators": "验证器",
    "Run Validation": "运行验证",
    "Search sandbox agents...": "搜索沙盒代理...",
    "Agent Marketplace": "代理市场",
    "Deploy specialized humanoid agents for real-world tasks": "部署专业人形代理执行实际任务",
    "Agents Available": "可用代理",
    "Try Agent": "试用代理",
    "Search marketplace agents...": "搜索市场代理...",
    "Production": "生产",
    "Experimental": "实验性",
    
    // Agent names
    "Locomotion Stress Validator": "运动压力验证器",
    "Precision Manipulation Lab": "精密操作实验室",
    "Human Interaction Simulator": "人机交互模拟器",
    "Energy Drain Profiler": "能量消耗分析器",
    "Terrain Adaptation Tester": "地形适应测试器",
    "Home Butler": "家庭管家",
    "Elder Companion": "老年陪伴",
    "Warehouse Picker": "仓库拣选员",
    "Hotel Concierge": "酒店礼宾",
    "Security Patrol": "安全巡逻",
    "Personal Fitness Coach": "个人健身教练",
    
    // Superbrain page - EVERY WORD
    "Superbrain Network": "超级大脑网络",
    "Global decentralized intelligence infrastructure": "全球去中心化智能基础设施",
    "OPERATIONAL": "运营中",
    "Total Nodes": "总节点",
    "Active Validators": "活跃验证者",
    "Total Inference": "总推理",
    "Network TPS": "网络TPS",
    "Network Throughput (24h)": "网络吞吐量（24小时）",
    "Regional Distribution": "区域分布",
    "Region": "区域",
    "Nodes": "节点数",
    "Percentage": "百分比",
    
    // Dashboard page
    "Network Overview": "网络概览",
    "Quick Stats": "快速统计",
    "Active Robots": "活跃机器人",
    "Inference Jobs": "推理作业",
    "Verified Actions": "已验证操作",
    "Compute Balance": "计算余额",
    "Network Activity": "网络活动",
    "Performance Metrics": "性能指标",
    "Welcome back": "欢迎回来",
    "Here's your network overview for today": "这是您今天的网络概览",
    "Try Cerebro": "试用Cerebro",
    "AI POWERED": "AI驱动",
    "Your intelligent assistant with 10 specialized modes — from Executive Advisory to Creative Brainstorming. Ask anything.": "您的智能助手拥有10种专业模式 — 从高管咨询到创意头脑风暴。问任何问题。",
    "Open Cerebro": "打开Cerebro",
    "Active Robots": "活跃机器人",
    "Inference Jobs": "推理作业",
    "Verified Actions": "已验证操作",
    "Compute Balance": "计算余额",
    "Network Uptime": "网络运行时间",
    "Latency": "延迟",
    "Learning Rate": "学习率",
    "Training Throughput": "训练吞吐量",
    "Agent Usage Distribution": "代理使用分布",
    "Navigation": "导航",
    "Perception": "感知",
    "Manipulation": "操纵",
    "Safety": "安全",
    "Other": "其他",
    "Rewards This Week": "本周奖励",
    "Node Distribution": "节点分布",
    "US-WEST": "美国西部",
    "US-EAST": "美国东部",
    "EU-WEST": "欧洲西部",
    "ASIA-PAC": "亚太地区",
    
    // Nodes page
    "Your Robots & Edge Devices": "您的机器人和边缘设备",
    "Manage your humanoid robots and compute nodes": "管理您的人形机器人和计算节点",
    "Add Node": "添加节点",
    "Search nodes...": "搜索节点...",
    "Name": "名称",
    "Status": "状态",
    "Hardware": "硬件",
    "Location": "位置",
    "Trust Score": "信任分数",
    "Actions": "操作",
    "Online": "在线",
    "Offline": "离线",
    "View Details": "查看详情",
    
    // Proofs page
    "Cryptographic Proof Explorer": "加密证明浏览器",
    "Browse inference and action proofs with zk verification": "浏览带有零知识验证的推理和操作证明",
    "All Proofs": "所有证明",
    "Inference": "推理",
    "Action": "操作",
    "ZK Receipt": "零知识收据",
    "Search proofs...": "搜索证明...",
    "Proof ID": "证明ID",
    "Type": "类型",
    "Verified": "已验证",
    "Timestamp": "时间戳",
    
    // Agent descriptions (short versions for cards)
    "Your personal home assistant. Cleans rooms, puts things away, greets visitors, and helps with simple cooking tasks. Safe around kids and pets.": "您的个人家庭助手。打扫房间，整理物品，迎接访客，协助简单的烹饪任务。对儿童和宠物安全。",
    "A caring companion for seniors. Reminds about medications, helps with walking, detects falls, and provides conversation. HIPAA-compliant and gentle.": "关心老年人的陪伴。提醒用药，协助行走，检测跌倒，提供对话。符合HIPAA且温和。",
    "Warehouse robot that finds and picks items from shelves all day. Works alongside humans safely and handles thousands of orders per shift.": "仓库机器人，全天从货架上寻找和拣选物品。与人类安全协作，每班处理数千个订单。",
    "Welcomes hotel guests, carries their bags, answers questions about the area, and coordinates room service. Professional, friendly, and available 24/7.": "欢迎酒店客人，搬运行李，回答有关该地区的问题，协调客房服务。专业、友好且24/7可用。",
    "Patrols your facility 24/7 checking for break-ins, unusual activity, or safety hazards. Alerts security team and provides live video on demand.": "24/7巡逻您的设施，检查入侵、异常活动或安全隐患。警报安全团队并按需提供实时视频。",
    "Personal trainer robot that shows you how to exercise correctly, counts your reps, fixes your form, and cheers you on. Available 24/7 for workouts.": "个人教练机器人，向您展示如何正确锻炼，计算次数，纠正姿势，为您加油。24/7可用于锻炼。",
    
    // Sandbox descriptions
    "Tests if your robot can walk safely on different surfaces and slopes without falling. Runs in simulation first to find balance issues before real-world deployment.": "测试您的机器人是否可以在不同表面和坡度上安全行走而不跌倒。首先在模拟中运行以在实际部署前发现平衡问题。",
    "Tests your robot's ability to pick up fragile items like eggs or glassware without breaking them. Perfect for training household or warehouse bots.": "测试您的机器人拾起脆弱物品（如鸡蛋或玻璃器皿）而不破坏它们的能力。非常适合训练家用或仓库机器人。",
    "Simulates humans walking near your robot to ensure it always maintains safe distances and stops if someone gets too close. Essential before deploying in homes or offices.": "模拟人类在您的机器人附近行走，以确保它始终保持安全距离并在有人靠得太近时停止。在家庭或办公室部署前至关重要。",
    "Tells you exactly how long your robot's battery will last doing specific tasks. Helps you plan charging schedules and avoid mid-task shutdowns.": "准确告诉您机器人的电池执行特定任务能持续多久。帮助您规划充电计划并避免任务中途关机。",
    "Tests if your robot can safely walk on carpet, tile, grass, gravel, and wet surfaces without slipping. Ensures reliable indoor and outdoor operation.": "测试您的机器人是否可以在地毯、瓷砖、草地、砾石和湿表面上安全行走而不打滑。确保可靠的室内和室外操作。"
  },
  
  es: {
    // Navigation
    "Cerebro": "Cerebro",
    "Dashboard": "Panel",
    "Nodes": "Nodos",
    "Sandbox": "Sandbox",
    "Superbrain": "Supercerebro",
    "Proof Logs": "Registros de Prueba",
    "Compute Credits": "Créditos de Cómputo",
    "Marketplace": "Mercado",
    "RoboMesh": "RoboMesh",
    "Governance": "Gobernanza",
    "Settings": "Configuración",
    
    // Common
    "Loading...": "Cargando...",
    "Search": "Buscar",
    "Thinking...": "Pensando...",
    "Reasoning...": "Razonando...",
    
    // RoboMesh
    "Simple Mode": "Modo Simple",
    "Expert Mode": "Modo Experto",
    "Solve": "Resolver",
    "Simulate": "Simular",
    "Insights": "Perspectivas"
  },
  
  fr: {
    "Cerebro": "Cerebro",
    "Dashboard": "Tableau de bord",
    "Nodes": "Nœuds",
    "Sandbox": "Bac à sable",
    "Superbrain": "Supercerveau",
    "Marketplace": "Marché",
    "RoboMesh": "RoboMesh",
    "Settings": "Paramètres",
    "Simple Mode": "Mode Simple",
    "Expert Mode": "Mode Expert"
  },
  
  de: {
    "Cerebro": "Cerebro",
    "Dashboard": "Dashboard",
    "Nodes": "Knoten",
    "Sandbox": "Sandbox",
    "Marketplace": "Marktplatz",
    "RoboMesh": "RoboMesh",
    "Settings": "Einstellungen",
    "Simple Mode": "Einfacher Modus",
    "Expert Mode": "Experten-Modus"
  },
  
  ja: {
    "Cerebro": "セレブロ",
    "Dashboard": "ダッシュボード",
    "Nodes": "ノード",
    "Sandbox": "サンドボックス",
    "Marketplace": "マーケットプレイス",
    "RoboMesh": "ロボメッシュ",
    "Settings": "設定"
  }
};

export const translate = (text, language) => {
  if (language === 'en' || !text) return text;
  return TRANSLATIONS[language]?.[text] || text;
};
